import { Center, Stack, Text, VStack } from '@chakra-ui/react';
import { Button } from '@diamond/shared/ui';
import NextLink from 'next/link';
import React from 'react';

interface ShoppingListErrorProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  backHref?: string;
  retryLabel?: string;
  backLabel?: string;
}

export const ShoppingListError: React.FC<ShoppingListErrorProps> = ({
  title = 'Terjadi kesalahan saat memuat data',
  description = 'Silakan periksa koneksi Anda atau coba lagi.',
  onRetry,
  backHref,
  retryLabel = 'Coba lagi',
  backLabel = 'Kembali ke Daftar',
}) => {
  return (
    <Center py={16} px={4}>
      <VStack spacing={4} maxW="lg" textAlign="center">
        <Stack spacing={1}>
          <Text as="b" fontSize={{ base: 'lg', md: 'xl' }}>
            {title}
          </Text>
          <Text color="gray.75" fontSize={{ base: 'sm', md: 'md' }}>
            {description}
          </Text>
        </Stack>
        <Stack direction={{ base: 'column', md: 'row' }} spacing={3} pt={2}>
          {onRetry && (
            <Button variant="solid" onClick={onRetry} aria-label="retry-load">
              {retryLabel}
            </Button>
          )}
          {backHref && (
            <Button as={NextLink} href={backHref} aria-label="back-to-list">
              {backLabel}
            </Button>
          )}
        </Stack>
      </VStack>
    </Center>
  );
};
